import { $document, $window } from '../global';
import { LoadingSpinner } from './loading-spinner';
var HighchartsState;
(function (HighchartsState) {
    HighchartsState[HighchartsState["UNAVAILABLE"] = 0] = "UNAVAILABLE";
    HighchartsState[HighchartsState["LOADING"] = 1] = "LOADING";
    HighchartsState[HighchartsState["AVAILABLE"] = 2] = "AVAILABLE";
})(HighchartsState || (HighchartsState = {}));
class ChartsManager {
    Highcharts;
    dynamicChartsIndex = 1;
    colors = {
        white: '#ffffff',
        lightgrey: '#f5f5f5',
        lightgrey3: '#dcdcdc',
        grey: '#969696',
        grey2: '#727272',
        darkgrey: '#464646',
        umcblue: '#00AFDC',
        researchblue: '#006991',
        orange2: '#f5ab24',
        purple: '#A63387',
        green: '#a1c233',
        pink: '#e53363'
    };
    resizeTimeout;
    highchartsState = HighchartsState.UNAVAILABLE;
    retryBtnText;
    failedToLoadText;
    loadingSpinners = [];
    constructor() {
        this.initResourceStrings();
        $document.ready(() => {
            this.resize();
        });
        $window.on('resize', () => {
            this.resizeStatic();
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = window.setTimeout(() => this.resize(), 250);
        });
    }
    initResourceStrings() {
        const data = $('.js-ChartsData');
        this.retryBtnText = data.data('retry-btn-text') || 'Grafiek opnieuw laden';
        this.failedToLoadText = data.data('failed-to-load-text') || 'We konden de grafiek niet laden. Controleer je internetverbinding en probeer het opnieuw.';
    }
    resize() {
        this.resizeStatic();
        this.resizeDynamic();
    }
    // Static
    resizeStatic() {
        // Old class: highcharts-container
        $(':not(.highcharts_dynamic-container) > .highcharts-container').each((i, elem) => {
            const $el = $(elem);
            if (!$el.is(':visible'))
                return;
            const svg = $el.find('svg');
            if (!svg.length)
                return;
            const width = parseInt(svg.attr('width'));
            const height = parseInt(svg.attr('height'));
            if (isNaN(width) || isNaN(height))
                return;
            const realWidth = svg.outerWidth();
            const realHeight = height * (realWidth / width);
            svg.css({
                width: '100%',
                height: realHeight
            });
        });
    }
    // Dynamic
    findAndInitDynamic() {
        if (!this.hasNewDynamic())
            return false;
        if (this.highchartsState === HighchartsState.AVAILABLE) {
            this.initDynamicCharts();
            return true;
        }
        if (this.highchartsState === HighchartsState.UNAVAILABLE) {
            this.initHighchartsLibrary();
        }
        return false;
    }
    hasNewDynamic() {
        return !!this.getNewDynamicCharts().length;
    }
    async initHighchartsLibrary() {
        this.highchartsState = HighchartsState.LOADING;
        this.removeRetryAlerts();
        this.showLoadingSpinners();
        try {
            this.Highcharts = (await import('./../libraries/highcharts')).default;
            this.highchartsState = HighchartsState.AVAILABLE;
            this.hideLoadingSpinners();
            this.initDynamicTheme();
            this.initDynamicCharts();
        }
        catch (ex) {
            console.error(`The Highcharts library could not be loaded: ${ex || 'No network connection'}`);
            this.highchartsState = HighchartsState.UNAVAILABLE;
            this.hideLoadingSpinners();
            this.showRetryAlert();
        }
    }
    showRetryAlert() {
        const dynamicCharts = this.getNewDynamicCharts();
        if (!dynamicCharts.length)
            return;
        const alert = $(`<div class="highcharts_dynamic-alert js-highcharts-dynamic-alert" style="display: none">
                    <div class="highcharts_dynamic-alert-text">${this.failedToLoadText}</div>
                    <button class="Btn Btn-Accent js-RetryBtn">${this.retryBtnText}</button>
                  </div>`);
        alert.find('.js-RetryBtn').on('click', () => {
            this.fadeOutRetryAlerts();
            setTimeout(() => {
                this.removeRetryAlerts();
            }, 600);
            setTimeout(() => {
                this.findAndInitDynamic();
            }, 1000);
        });
        alert.insertAfter(dynamicCharts).fadeIn();
    }
    fadeOutRetryAlerts() {
        $('.js-highcharts-dynamic-alert').fadeOut(400, function () {
            $(this).css({ display: 'block', opacity: 0 });
        });
    }
    removeRetryAlerts() {
        $('.js-highcharts-dynamic-alert').fadeOut(400, function () {
            $(this).remove();
        });
    }
    initDynamicTheme() {
        const colors = this.colors;
        this.Highcharts.theme = {
            colors: [colors.umcblue, colors.researchblue, colors.orange2, colors.purple, colors.green, colors.pink, colors.darkgrey, colors.grey],
            chart: {
                backgroundColor: colors.white
            },
            title: {
                style: {
                    color: colors.darkgrey,
                    font: 'bold 22px Calibri, sans-serif'
                }
            },
            subtitle: {
                style: {
                    color: colors.grey,
                    font: '16px Calibri, sans-serif'
                }
            },
            legend: {
                itemStyle: {
                    font: '16px Calibri, sans-serif',
                    color: colors.darkgrey
                },
                itemHoverStyle: {
                    color: colors.darkgrey
                }
            }
        };
        this.Highcharts.setOptions(this.Highcharts.theme);
    }
    getNewDynamicCharts() {
        return $('.highcharts_dynamic-container:not(.chart-loaded):visible');
    }
    initDynamicCharts() {
        if (!this.highchartsState)
            return;
        this.getNewDynamicCharts().each((index, elem) => {
            try {
                const $elem = $(elem);
                const $data = $elem.find('.highcharts_dynamic-data');
                let config;
                const data = $data.text();
                try {
                    config = JSON.parse(data);
                }
                catch (ex) {
                    console.error(`Couldn't load the dynamic chart: Invalid json data. (${data})`);
                }
                if (!config)
                    return;
                config = this.addDefaultsToConfig(config);
                const id = `highchart-dynamic-${this.dynamicChartsIndex}`;
                $elem.attr('id', id);
                config.chart.renderTo = id;
                this.dynamicChartsIndex++;
                const chart = this.Highcharts.chart(config);
                $elem.data('chart', chart);
                $elem.addClass('chart-loaded');
                // $elem.highcharts(config); //Old way without chart as return
            }
            catch (ex) {
                console.error(`Couldn't load the dynamic chart: ${ex.stack})`);
            }
        });
    }
    addDefaultsToConfig(config) {
        const colors = this.colors;
        config.chart.reflow = false;
        config.chart.panning = null;
        // config.chart.panKey = 'alt';
        config.chart.zooming = {
            ...config.chart.zooming,
            type: 'xy',
            pinchType: null
        };
        config.chart.plotBorderColor = colors.lightgrey;
        config.chart.plotBorderWidth = 1;
        config.chart.animation = false;
        // config.tooltip = {
        //   // backgroundColor: this.colors.lightgrey,
        //   // borderColor: this.colors.darkgrey,
        //   // borderRadius: 0,
        //   // borderWidth: 0
        // };
        // config.navigation = {
        //   buttonOptions: likeResetZoomButton
        // };
        config.chart.resetZoomButton = {
            theme: {
                'stroke-width': 0,
                r: 2,
                fill: colors.researchblue,
                style: {
                    color: colors.white,
                    'font-weight': 'bold',
                    'font-family': 'Calibri',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                    cursor: 'pointer'
                },
                states: {
                    hover: {
                        fill: colors.lightgrey,
                        style: {
                            color: colors.researchblue,
                            'font-weight': 'bold',
                            'font-family': 'Calibri',
                            'font-size': '13px',
                            'text-transform': 'uppercase',
                            cursor: 'pointer'
                        }
                    }
                }
            }
        };
        config.credits = {
            href: 'https://www.radboudumc.nl',
            text: 'Radboudumc'
        };
        if (config.xAxis)
            config.xAxis = this.styleAxis(config.xAxis);
        if (config.yAxis)
            config.yAxis = this.styleAxis(config.yAxis);
        if (config.series)
            config.series = this.styleSeries(config.series);
        return config;
    }
    resizeDynamic() {
        if (!this.findAndInitDynamic())
            return;
        $('.highcharts_dynamic-container.chart-loaded').each(function () {
            const $this = $(this);
            const chart = $this.data('chart');
            if (!chart)
                return;
            chart.setSize(null, null, false);
        });
    }
    hideLoadingSpinners() {
        for (let i = 0; i < this.loadingSpinners.length; i++) {
            const loadingSpinner = this.loadingSpinners[i];
            loadingSpinner.html.remove();
            loadingSpinner.hide();
        }
        this.loadingSpinners = [];
    }
    showLoadingSpinners() {
        const charts = this.getNewDynamicCharts();
        for (let i = 0; i < charts.length; i++) {
            const loadingSpinner = new LoadingSpinner(true, false, true);
            loadingSpinner.html.insertAfter(charts[i]);
            loadingSpinner.show(500);
            this.loadingSpinners.push(loadingSpinner);
        }
    }
    styleAxis(list) {
        const color1 = this.colors.lightgrey3;
        for (let i = 0; i < list.length; i++) {
            const axis = list[i];
            axis.gridLineColor = color1;
            axis.lineColor = color1;
            axis.minorGridLineColor = color1;
            axis.minorTickColor = color1;
            axis.tickColor = color1;
            list[i] = axis;
        }
        return list;
    }
    styleSeries(series) {
        const colors = this.colors;
        const chartColors = [colors.umcblue, colors.researchblue, colors.orange2, colors.purple, colors.green, colors.pink, colors.darkgrey, colors.grey];
        let colorIndex = 0;
        for (let i = 0; i < series.length; i++) {
            if (!series[i].color)
                continue;
            series[i].color = chartColors[colorIndex];
            colorIndex++;
            if (chartColors.length <= colorIndex)
                colorIndex = 0;
        }
        return series;
    }
}
const chartsManager = new ChartsManager();
export { chartsManager };
